import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { adminHttp } from "~/Admin/services/http";
import { produce } from "immer";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import ValidationError from "~/Components/Forms/ValidationError";
import classnames from "classnames";
import Moment from "react-moment";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
import Translated from "~/Admin/AdminMultilang/Translated";
import { toast } from 'react-toastify';

const AdminWaveManagement = ({ match, event, ...props }) => {

    const [response, setResponse] = useState([]);
    const [selected, setSelected] = useState(null);
    const [dateFromFocused, setDateFromFocused] = useState(false);
    const [dateToFocused, setDateToFocused] = useState(false);

    const [form, setForm] = useState({
        name: '',
        date_from: null,
        date_to: null,
        display_order: 0,
        translations: {}
    });

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const loadData = () => {
        adminHttp
            .get('/events/' + event.id + '/waves',)
            .then(res => {
                setResponse(res.data);
                setSelected(res.data[0]);
            });
    };

    const handleAddWave = () => {
        toast.promise(
            adminHttp.post('/events/' + event.id + '/waves'),
            {
                pending: 'Adding wave...',
                success: {
                    render(res) {
                        setResponse(res.data?.data);
                        return 'New wave added'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    const handleDeleteWave = () => {
        toast.promise(
            adminHttp.delete('/events/' + event.id + '/waves/' + selected.id),
            {
                pending: 'Deleting wave...',
                success: {
                    render() {
                        loadData();
                        return 'Wave deleted'
                    }
                },
                error: 'Something went wrong!'
            }
        )
    };

    useEffect(loadData, [event]);

    useEffect(() => {

        setForm(produce(form, (draft) => {
            if (selected) {
                draft.name = selected.name;
                draft.date_from = moment(selected.date_from);
                draft.date_to = moment(selected.date_to);
                draft.display_order = selected.display_order;
                draft.translations = selected.translations;
            }
        }));

        setSuccess(null);
        setError(null);

    }, [selected]);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setForm({ ...form, [name]: value });
    };

    const handleDateChange = (date, name) => {
        let formData = { ...form, [name]: date };
        setForm(formData);
    };

    const handleSave = () => {
        toast.promise(
            adminHttp.put('/events/' + event.id + '/waves/' + selected.id, form),
            {
                pending: 'Saving wave...',
                success: {
                    render(res) {
                        setError(null);
                        setSuccess('Wave has been saved!');

                        let indx = response.findIndex(row => row.id === selected.id);

                        setResponse(produce(response, (draft) => {
                            draft[indx] = res.data?.data;
                        }));
                        return 'Wave saved'
                    }
                },
                error: {
                    render(error) {
                        setSuccess(null);
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (

        <div className="admin-wave">
            <div className="row">
                <div className="col-8">
                    <h2>Wave Management</h2>
                </div>
                <div className="col-4 text-right">
                    <ConfirmedButton onClick={handleAddWave} className="btn btn-primary btn-sm">
                        + New Wave
                    </ConfirmedButton>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-3">
                    <div className="list-group">
                        {response.map(item =>
                            <a key={item.id} onClick={(e) => setSelected(item)}
                                className={classnames('list-group-item list-group-item-action cursor-pointer', { active: selected?.id === item.id })}>
                                {item.name} <small className="float-right"><Moment format="DD/MM/YYYY" date={item.date_from} /> - <Moment format="DD/MM/YYYY" date={item.date_to} /></small>
                            </a>
                        )}
                    </div>
                </div>
                {selected && (
                    <div className="col-9">
                        <h3>Edit Wave</h3>

                        {success && (
                            <div className="alert alert-success" role="alert">
                                {success}
                            </div>
                        )}

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error.message || "Error saving wave!"}
                            </div>
                        )}

                        <div className="form-group required">
                            <label>Wave Name</label>

                            <Translated translations={form.translations}
                                onChanged={(values) => setForm({ ...form, translations: values })}>
                                <input
                                    onChange={handleChange}
                                    value={form.name}
                                    name="name"
                                    type="text"
                                    className="form-control" />
                            </Translated>

                            <ValidationError errors={error?.errors} name="name" />

                        </div>

                        <div className="form-group required">
                            <label>Date From</label>

                            <div>
                                <SingleDatePicker
                                    keepOpenOnDateSelect={false}
                                    hideKeyboardShortcutsPanel={true}
                                    openDirection={'up'}
                                    numberOfMonths={1}
                                    date={form.date_from}
                                    onDateChange={(date) => handleDateChange(date, 'date_from')}
                                    focused={dateFromFocused}
                                    onFocusChange={(f) => setDateFromFocused(f.focused)}
                                    id="wave_date_from"
                                    displayFormat={() => "DD/MM/YYYY"}
                                />
                            </div>

                            <ValidationError errors={error?.errors} name="date_from" />

                        </div>

                        <div className="form-group required">
                            <label>Date To</label>

                            <div>
                                <SingleDatePicker
                                    keepOpenOnDateSelect={false}
                                    hideKeyboardShortcutsPanel={true}
                                    openDirection={'up'}
                                    numberOfMonths={1}
                                    date={form.date_to}
                                    onDateChange={(date) => handleDateChange(date, 'date_to')}
                                    focused={dateToFocused}
                                    onFocusChange={(f) => setDateToFocused(f.focused)}
                                    id="wave_date_to"
                                    displayFormat={() => "DD/MM/YYYY"}
                                />

                            </div>

                            <ValidationError errors={error?.errors} name="date_to" />

                        </div>

                        <div className="form-group">
                            <label>Display Order</label>

                            <input
                                onChange={handleChange}
                                value={form.display_order}
                                name="display_order"
                                type="text"
                                className="form-control" />

                            <ValidationError errors={error?.errors} name="display_order" />

                        </div>

                        <div className="form-group">
                            <button
                                onClick={handleSave}
                                className="btn btn-primary btn-sm float-right">
                                Save Wave
                            </button>

                            <ConfirmedButton
                                confirmText="Are you sure you want to delete ?"
                                onClick={handleDeleteWave}
                                className="btn btn-secondary btn-sm mr-3 float-right">
                                Delete Wave
                            </ConfirmedButton>
                        </div>
                    </div>)}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminWaveManagement);
